module.exports = __webpack_public_path__ + "img/sec2_bank_img6.c06592ee.png";